import { createSlice } from '@reduxjs/toolkit'

export const listModalSlice = createSlice({
    name: 'isListModalOpen',
    initialState: {
        value: false
    },
    reducers: {
        openListModal: state => {
            state.value = true;
        },
        closeListModal: state => {
            state.value = false;
        }
    }
});

export const {openListModal, closeListModal} = listModalSlice.actions;